import { render, staticRenderFns } from "./PropertySelectMultipleColoredTag.vue?vue&type=template&id=60f074a3&"
import script from "./PropertySelectMultipleColoredTag.vue?vue&type=script&lang=js&"
export * from "./PropertySelectMultipleColoredTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/krankerl.FFR503Cp8cB3/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60f074a3')) {
      api.createRecord('60f074a3', component.options)
    } else {
      api.reload('60f074a3', component.options)
    }
    module.hot.accept("./PropertySelectMultipleColoredTag.vue?vue&type=template&id=60f074a3&", function () {
      api.rerender('60f074a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor/Properties/PropertySelectMultipleColoredTag.vue"
export default component.exports